import React from 'react';
import IconWrapper from '../IconWrapper';
const ReturnIcon = (props) => (React.createElement(IconWrapper, Object.assign({}, props),
    React.createElement("path", { d: "M17.508 9h-5.756l4.451 4.293-.707.707-4.983-4.805-.013.012-.707-.707.707-.707.013.013L15.5 3l.707.707L11.752 8H18c3.59 0 6 2.91 6 6.5a6.5 6.5 0 0 1-6 6.481V21H0v-1h17.5a5.5 5.5 0 0 0 5.5-5.5c0-3.038-1.962-5.5-5-5.5h-.492z" })));
export default ReturnIcon;
//# sourceMappingURL=ReturnIcon.js.map